import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible/index.js";
import { get, post } from "../request/http";
import wx from "weixin-jsapi";


Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.wx = wx;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.name == "WxIndex"||to.name == "WxList"||to.name == "WxOrder") {
    //扫码页
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  } else {
    if (sessionStorage.getItem("ticket")) {
      //登录状态
      if (to.name === "Login") {
        router.push({
          path: "/",
        });
        next();
      } else {
        next();
      }
    } else {
      //未登录状态
      if (to.name !== "Login") {
        next({
          replace: true,
          name: "Login",
        });
      } else {
        next();
      }
    }
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
